// Taxonomy: maps raw inventory categories to a tight, customer-friendly set.
// Each display category has a label, slug used in URL/?category, and the list
// of raw categories that map to it (case-insensitive match).
import { Gem, Sparkles, Heart, Link2, Circle, Crown, Watch, Hand, Layers } from "lucide-react";

export const CATEGORIES = [
  { slug: "rings",       label: "Rings",              icon: Circle,    raws: ["Rings", "Ladies", "Diamond"] },
  { slug: "earrings",    label: "Earrings",           icon: Sparkles,  raws: ["Earring", "Tops", "Jhumki"] },
  { slug: "pendants",    label: "Pendants",           icon: Heart,     raws: ["Pendant", "DIAMOND PANDENT", "DIAMOND PENDANT"] },
  { slug: "chains",      label: "Chains & Necklaces", icon: Link2,     raws: ["Chain"] },
  { slug: "bangles",     label: "Bangles & Karra",    icon: Crown,     raws: ["Karra", "Bangles", "Bangle"] },
  { slug: "bracelets",   label: "Bracelets",          icon: Hand,      raws: ["Bracelet"] },
  { slug: "sets",        label: "Sets",               icon: Layers,    raws: ["Set", "Jewellery Set", "Bridal Set", "Mangal"] },
  { slug: "diamonds",    label: "Diamonds",           icon: Gem,       raws: ["DIAMOND LOOSE CUT & POLISHED"] },
  { slug: "gold",        label: "Gold Classics",      icon: Watch,     raws: ["Gold"] },
];

const RAW_TO_SLUG = (() => {
  const m = {};
  CATEGORIES.forEach((c) => c.raws.forEach((r) => { m[r.toLowerCase().trim()] = c.slug; }));
  return m;
})();

export const slugFor = (rawCategory) => RAW_TO_SLUG[(rawCategory || "").toLowerCase().trim()] || null;

export const matchesSlug = (item, slug) => {
  if (!slug || slug === "all") return true;
  return slugFor(item.category) === slug;
};
